import { Reveal } from "./Reveal";

export default function SectionHead({ chapter, eyebrow, title, center = false }) {
  return (
    <Reveal className={center ? "text-center" : ""}>
      <p className="text-xs uppercase tracking-[0.22em] text-[#c9a24a]">
        <span className="mr-3 text-[#c9a24a]/50">{chapter}</span>
        {eyebrow}
      </p>
      <h2 className="mt-4 font-display text-4xl font-light leading-tight text-[#f4ecdd] md:text-5xl">
        {title}
      </h2>
    </Reveal>
  );
}
